<template>
  <v-app-bar color="appBar" elevation="2">
    <template v-slot:prepend>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </template>
    <v-app-bar-title>Customer Compass</v-app-bar-title>
    <v-btn icon>
      <v-icon>mdi-dots-vertical</v-icon>
      <v-dialog activator="parent" max-width="500">
          <template v-slot:default="{ isActive }">
            <v-card title="Over ons">
              Verhaal
            </v-card>
          </template>
        </v-dialog>
    </v-btn>
  </v-app-bar>
  <v-navigation-drawer v-model="drawer" :location="$vuetify.display.mobile ? 'bottom' : undefined" temporary>
    <v-list :items="items" nav>
      <template v-for="item in items">
        <v-list-item>
        <NuxtLink :to="item.value" class="no-underline">{{item.title}}</NuxtLink>
        </v-list-item>
    </template>
    </v-list>
  </v-navigation-drawer>
  <v-main>
    <NuxtPage />
  </v-main>
</template>

<script lang="ts" setup>
definePageMeta({
  auth: false
})

const drawer = ref(false);
const items = [
  {
    title: 'Rapport genereren',
    value: '/generatereport',
  },
  {
    title: 'Kennisdocumenten beheren',
    value: '/summary',
  },
  {
    title: 'Rapporten beheren',
    value: '/manageReports',
  },
  {
    title: 'Prompts beheren',
    value: '/managePrompts',
  },
  {
    title: 'Klantsituatie bepalen',
    value: '',
  },
];
</script>

<style>
.no-underline {
  text-decoration: none;
  color: inherit;
}

.no-underline:hover {
  text-decoration: none;
  color: inherit;
}

</style>